<template>
  <div class='PedidoItemView'>
    <div class="img-desc">
      <img v-if="data.img.length" :src="api + data.img[0].img">
      <span style="margin-left: 2%;display: block">
        <div>{{ data.name }}</div>
        <div>
          <label
          v-for="(a, key) in data.pedidoitematributos"
          :key="key"
          >
            {{ a.name }}: {{ a.value }}&nbsp;
          </label>
        </div>
      </span>
    </div>
    <div style="width: 10%">{{ data.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    <div style="width: 10%">{{ data.qtda }}</div>
    <div style="width: 10%">{{ (data.preco * data.qtda).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
  </div>
</template>

<script>
import api from '@/mixins/api'
export default {
  name: 'PedidoItemView',
  props: ['data'],
  mixins: [api],
}
</script>

<style scoped>
.PedidoItemView {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  width: 95%;
  padding: 1%;
  margin: auto;
}

.img-desc {
  width: 69%;
  text-align: left;
  display: flex;
  align-items: center;
  padding-left: 1%;
}

img {
  width: 50px;
  height: 50px;
}
</style>
